define('select2-patched',[
	"jquery",
	"select2",
	"jquery-throttle-debounce"
], function(
	$,
	Select2
) {
	// Place container before element instead of after
	var _origPlaceContainer = Select2.prototype._placeContainer;
	Select2.prototype._placeContainer = function ($container) {
		var res = _origPlaceContainer.apply(this, arguments);
		$container.insertBefore(this.$element);

		//console.log("install");
		//$(window).on("resize", $.debounce(250, $.proxy(function() {
		//	var width = this._resolveWidth(this.$element, this.options.get('width'));
		//	if (width != null) {
		//		$container.css('width', width);
		//	}
		//}, this)));

		return res;
	};

	return Select2;
});
